import Vue from 'vue'
import Vuex from 'vuex'
import http from '../../httpuntil'
Vue.use(Vuex)
// initial state
const state = {
    products: [],
    recommendProducts:[],
    categories: [],
    advertisements:[]
}

const getters = {
    // products: state => {
    //     return state.products;
    // },
    // categories: state => {
    //     return state.categories;
    // }
}
// actions
const actions = {
  setproducts({commit},val) {
   
    commit('setProducts',val)
  },
  getProducts ({commit},filter) {
      //var filter={CategoryID:{Value:categoryID}}
      console.log(filter)
      http.post("/api/product/list",filter,(data)=>{
        if (data.Success) {
          console.log(filter)
          if(filter.Title.Value==null && filter.Pager.PageNumber!=1) {
              var statepro = JSON.parse(JSON.stringify(state.products))
              console.log(state.products)
              data.Data.Results.forEach(function(vals,inds) {
                  statepro.Results.push(vals)
            })
                   
            data.Data.Results = statepro.Results
                  
          
         }
         commit('setProducts',data.Data);
        }
      },(e)=>{
        console.log(e);
      });
  },
  getRecommendProducts ({ commit},filter) {
   
    http.post("/api/product/recommendlist",filter,(data)=>{
      if (data.Success) {
        commit('setRecommendProducts',data.Data);
      }
    },(e)=>{
      console.log(e);
    });
  },
  getAllCategory:function({commit}){
    return new Promise ( (resolve, reject ) => {
      http.get("/api/product/salecategory",(data)=>{
        if (data.Success) {
          commit('setCategory', data.Data);
          resolve(data.Data[0].ID);
      }
      },(e)=>{
        console.log(e);
      });
    });
  },
  getAdvertisement:function({commit}){
    http.get("/api/advertisement/get",(data)=>{
      if (data.Success) {
        commit('setAdvertisement', data.Data);
    }
    },(e)=>{
        console.log(e);
    });
}
}

// mutations
const mutations = {
  setProducts (state, products) {
     state.products = products
  },
  setRecommendProducts (state, products) {
    state.recommendProducts = products
  },
  setCategory (state, categories) {
    state.categories = categories
  },
  setAdvertisement (state, advertisements) {
    state.advertisements = advertisements
  }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
